import myRequest from '@/utils/MyRequest';

let bathUrl = "https://www.chenxichem.com/";

export class api {
    
    getlogin ( data ) {
        return myRequest.post(bathUrl + "api/login", data);
    }

    getloginOut () {
        return myRequest.get(bathUrl + "api/logout" );
    }

    getUserDetial ( ) {
        return myRequest.get(bathUrl + "api/getLoginUser" );
    }

    postUserList ( data ) {
        return myRequest.post(bathUrl + "api/sysUser/page", data);
    }

    postAddUser ( data ) {
        return myRequest.post(bathUrl + "api/sysUser/add", data);
    }

    postDeleteUser ( data ) {
        return myRequest.post(bathUrl + "api/sysUser/delete", data);
    }

    postEditUserInfo ( data ) {
        return myRequest.post(bathUrl + "api/sysUser/edit", data);
    }

    postProductList ( data ) {
        return myRequest.post(bathUrl + "api/product/page", data);
    }

    postProductListD ( data ) {
        return myRequest.post(bathUrl + "api/product/list", data);
    }

    postAddProduct ( data ) {
        return myRequest.post(bathUrl + "api/product/add", data);
    }

    postEditProduct ( data ) {
        return myRequest.post(bathUrl + "api/product/edit", data);
    }

    postDeleteProduct ( data ) {
        return myRequest.post(bathUrl + "api/product/delete", data);
    }

    postUploadImage ( data ) {
        return myRequest.post(bathUrl + "api/sysFileInfo/upload", data);
    }

    getSysFileInfoPreview ( data ) {
        return myRequest.get( bathUrl + "api/sysFileInfo/preview", data );
    }

    postNewsList ( data ) {
        return myRequest.post( bathUrl + "api/sysNews/page", data );
    }

    postNewsListD ( data ) {
        return myRequest.post( bathUrl + "api/sysNews/list", data );
    }

    postAddNews ( data ) {
        return myRequest.post(bathUrl + "api/sysNews/add", data);
    }

    postModifyNews ( data ) {
        return myRequest.post(bathUrl + "api/sysNews/edit", data);
    }

    postDeleteNews ( data ) {
        return myRequest.post(bathUrl + "api/sysNews/delete", data);
    }
    
}

export default new api()